export default __webpack_public_path__ + "static/media/loading.d6fb07a0.svg";